import { createSelector } from 'redux-bundler'

import { minutes } from 'milliseconds'

import createListBundle from '~/src/Lib/createListBundle'
import { WasteType as schema } from '~/src/Store/Schemas'

export const initialState = {
  search: '',
  ordering: ['name', 'asc'],
}

const { selectWasteTypeListShouldUpdate, ...initialBundle } = createListBundle({
  entityName: 'wasteType',
  initialState,
  schema,
  fetchHandler: ({ apiFetch, params }) => apiFetch('/wasteTypes/', { ...params, pagination: 0 }),
  flags: { keys: ['METRC'] },
  staleAfter: minutes(60),
})

export default {
  ...initialBundle,
  selectWasteTypeListShouldNormallyUpdate: selectWasteTypeListShouldUpdate,
  selectWasteTypeListShouldUpdate: createSelector(
    'selectWasteTypeListShouldNormallyUpdate',
    'selectWasteTypeListRaw',
    'selectCurrentMetrcFacilities',
    'selectIsOnline',
    (shouldNormallyUpdate, { failedPermanently, lastSuccess, isLoading }, metrcFacilities, isOnline) => {
      if (shouldNormallyUpdate) return true

      if (!isOnline || failedPermanently || isLoading) return false

      const syncedSinceLastFetch = metrcFacilities.some(
        metrcFacility => metrcFacility.lastWasteTypeRefresh && lastSuccess < new Date(metrcFacility.lastWasteTypeRefresh)
      )
      if (syncedSinceLastFetch) {
        return true
      }

      return false
    }
  ),
}
